import script from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SidenavItem.vue?vue&type=script&setup=true&lang=js"

import "./SidenavItem.vue?vue&type=style&index=0&id=4c48932a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c48932a"]])

export default __exports__